<script lang="ts" setup>
import type { VisiblePanel } from '~~/layers/chrome/types/panel';
import { computed } from 'vue';
import { usePaneStore } from '~~/layers/chrome/stores/pane';

const paneStore = usePaneStore();

const visiblePanels = computed(() => paneStore.panels.filter((panel): panel is VisiblePanel => !panel.hidden));

function isPanelActive(panelId: string) {
	return paneStore.panelOpen && paneStore.currentPanelId === panelId;
}

function togglePanel(panelId: string) {
	paneStore.togglePanel({ panelId });
}
</script>

<template>
	<div class="flex items-center gap-x-1">
		<DTooltip
			v-for="panel in visiblePanels"
			:key="panel.id"
			:text="panel.label"
		>
			<component
				:is="panel.toggleComponent"
				v-if="panel.toggleComponent"
				:active="isPanelActive(panel.id)"
				:aria-label="panel.label"
				@click="togglePanel(panel.id)"
			/>

			<DButton
				v-else
				size="sm"
				variant="ghost"
				color="neutral"
				:icon="panel.icon"
				:pressed="isPanelActive(panel.id)"
				:aria-label="panel.label"
				class="rounded-sm"
				@click="togglePanel(panel.id)"
			/>
		</DTooltip>
	</div>
</template>
